import { ITeamLeadPermissionsJson } from '@scale/shared/types/expertManagement';
import { useQuery } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFetchAdminGlobalTeamLeadPermissions = () => {
  return useQuery([`fetchAdminPermissions`], () =>
    apiFetch<{
      globalPermissions: ITeamLeadPermissionsJson[];
      podTypePermissions: ITeamLeadPermissionsJson[];
    }>(null, 'internal/expert-management/admin/permissions', {
      method: 'GET',
    }),
  );
};
